import RubricView from "@features/tools/view/rubric-view";

const Rubric = () => {
  return <RubricView />;
};

export default Rubric;
